import React, { useCallback, type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import useFeedbackDialog from '@atlassian/jira-issue-navigator-changeboarding/src/common/ui/opt-out-feedback';
import Toggle from '../../common/ui/toggle';
import { useToggle } from '../../common/ui/utils';
import messages from './messages';

export const TOGGLE_TEST_ID =
	'admin-pages-new-issue-search-transition.ui.lock-in-transition.toggle';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: {
	loading: boolean;
	value?: boolean;
	setLockInToggle: (arg1: boolean) => Promise<boolean | undefined>;
}) => {
	const { loading, value, setLockInToggle } = props;

	const { formatMessage } = useIntl();

	const isToggledOn = value || false;

	const [{ flag }, { onToggleSuccess, onToggleError, handleDismiss }] = useToggle({
		messages,
	});

	const { renderFeedbackDialog } = useFeedbackDialog({
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onClose: () => {},
		isAdminSettingsModal: true,
	});

	const handleToggleChange = useCallback(
		async (_: SyntheticEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEvent) => {
			const responseValue = await setLockInToggle(!value);
			if (responseValue === undefined) {
				onToggleError();
				return;
			}
			// Check for toggle off (i.e. opt-out) operation
			value === true && responseValue === false && renderFeedbackDialog();
			onToggleSuccess(responseValue, analyticsEvent);
		},
		[onToggleError, onToggleSuccess, setLockInToggle, value, renderFeedbackDialog],
	);

	return (
		<Toggle
			value={isToggledOn}
			isDisabled={false}
			loading={loading}
			onToggleChange={handleToggleChange}
			onFlagDismiss={handleDismiss}
			flag={flag}
			testId={TOGGLE_TEST_ID}
			toggleHeading={formatMessage(messages.moveUsersHeading)}
			toggleDescription={<FormattedMessage {...messages.moveUsersDescription} />}
		/>
	);
};
